<script>
    import Svgo from "./svgo.svelte";
</script>

<Svgo {...$$props} on:click>
    <g fill="none" stroke-width="1.5" stroke="currentColor"> 
        <path stroke-linecap="round" d="M3 12h18" />
    </g>
</Svgo>